import { useCallback, useEffect, useState } from "react"
import axios from 'axios'
import pluralize from 'pluralize'
import { useSnackbar } from 'notistack'
import { useDispatch } from 'react-redux'
import { message } from 'antd'

import { logout } from "./store/actions"

import Pagination from "./components/resusable/pagination"
import Modal from "./components/resusable/modal"

// export const host = localStorage.getItem('host')

// export const port = localStorage.getItem('port')

export const production = process.env.REACT_APP_ENV === 'production'

export const server = process.env.REACT_APP_API_URL || 'http://localhost:5400'

export const useToggle = (initialState = false) => {
    const [state, setState] = useState(initialState)

    const toggle = useCallback(() => setState(state => !state), [])

    return [state, toggle, setState]
}

export const plural = (unit, count) => pluralize(unit, count)

export const notifOps = (type, action = null, persist = false, duration = 3000) => ({
    variant: type,
    persist,
    autoHideDuration: persist ? null : duration,
    action
})

export const stringifyDate = (date, noTime = false) => {
    let d = new Date(date).toString()
    d = d.slice(0, d.indexOf(' GMT'))

    if (noTime)
        d = d.slice(0, d.lastIndexOf(' '))

    return d
}

export const normalize = (val, nearest = 100) => (Math.round(val * nearest) / nearest)

export const usePet = (endpoint = '', payload, { notify, callback = () => null, manual, load, hasFile, method = 'post', logOutOnError = false, token: tkn }) => {
    load = load ? {
        msg: load.msg || 'loading'
    } : null

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)
    const [lock, setLock] = useState(manual ? true : false)

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const dispatch = useDispatch()

    const kickOut = () => dispatch(logout())

    const errorNotif = msg => enqueueSnackbar(msg, notifOps('warning', () => (
        <button
            className="close-notif"
            onClick={ () => closeSnackbar() }>
            Close
        </button>
    ), true))

    const request = async () => {
        const form = hasFile ? new FormData() : {}

        for (let item in payload) {
            if (hasFile) {
                if (Array.isArray(payload[item])) {
                    form.append(item, JSON.stringify(payload[item]))
                } else {
                    form.append(item, payload[item])
                }
            } else {
                form[item] = payload[item]
            }
        }

        if (hasFile) {
            form.append('hasFile', true)
            form.append('timeStamp', new Date())
        } else {
            form.timeStamp = new Date()
        }

        try {
            setLoading(true)
            setError(false)
            let key
            if (manual && load)
                key = message.loading(load.msg)
            // key = enqueueSnackbar(loadingMsg, notifOps('info', loader, true))

            let token = sessionStorage.getItem('token')

            let response = await axios({
                url: `${server}/api/${endpoint}`,
                method,
                data: form,
                headers: token && { Authorization: `Bearer ${tkn ?? token}` }
            })

            setLoading(false)

            if (manual && load)
                key()
            // closeSnackbar(key)

            let { data: received } = response

            setData(received.data)
            callback(received, enqueueSnackbar, notifOps, closeSnackbar)
        } catch (err) {
            setLoading(false)
            setError(err)
            log({ err })

            if (notify) {
                if (err.response) {
                    if (err.response.data) {
                        if (err.response.data.message) {
                            errorNotif(err.response.data.message)
                        } else {
                            errorNotif(err.message)
                        }
                    } else {
                        errorNotif('An error occurred at our servers, please contact the admin.')
                    }
                } else if (err.request) {
                    errorNotif('We seem to be offline at the moment, please contact the admin.')
                } else {
                    errorNotif('You seem to be offline, please check your network connection')
                }
            }

            if (err.response?.data?.kickOut || logOutOnError)
                kickOut()
        }
    }

    const makeRequest = () => {
        if (!lock) {
            setLock(true)
            request()
        }
    }

    useEffect(makeRequest)

    const execute = () => setLock(false)

    if (!manual)
        makeRequest()

    return [{ loading, error, data }, execute]
}

export const log = item => production ? null : console.log(item)

export const useListData = (query, payload, options, name, lim = 10, callback = () => null) => {
    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(1)
    const [limit] = useState(lim)

    const [{ loading, error, data }, fetch] = usePet(query, {
        ...payload,
        page,
        limit
    }, {
        ...options,
        callback: ({ data }) => {
            setList(data[name ?? query])
            setCount(data.count)
            callback(data)
        }
    })

    const navigate = pg => {
        setPage(pg)
        fetch()
    }

    const Paginate = <Pagination total={count} limit={limit} page={page} navigate={navigate} />

    return [{ loading, error, fetch }, { list, count, data }, { navigate, page, limit, Paginate }]
}

export const getGradient = key => {
    let backgrounds = ['grad1', 'grad2', 'grad3', 'grad4']

    let mult = 4
    
    while (true) {
        if (key < mult)
            return backgrounds[(mult - 1) - key]
            
        mult += 4
    }
}

export const useElevated = () => {
    const [uname, setUname] = useState('')
    const [pwd, setPwd] = useState('')
    
    const { enqueueSnackbar } = useSnackbar()

    let onSuccess = () => null

    const [visible, toggle] = useToggle()

    const onComplete = ({}) => {
        onSuccess()
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('userLogin', {
        username: uname, 
        password: pwd,
        app: 'pos'
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Just a minute...' } })

    const enableUname = uname?.trim().length > 3
    const enablePwd = pwd?.trim().length > 3

    const performLogin = () => {
        if (!enableUname)
            enqueueSnackbar('Please enter a correct format for username', notifOps('warning'))

        if (!enablePwd)
            enqueueSnackbar('Please enter a correct format for password', notifOps('warning'))

        if (enableUname && enablePwd)
            execute()
    }

    const launch = fn => {
        onSuccess = fn
        toggle()
    }

    const onKeyUp = e => {
        if (e.keyCode === 13)
            performLogin()
    }

    let component = () => (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Admin Login Required"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Username
                    </label>
                    <input
                        onKeyUp={ onKeyUp }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-user-name"
                        type="text"
                        onChange={ e => setUname(e.target.value) }
                        placeholder="Username" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Password
                    </label>
                    <input
                        onKeyUp={ onKeyUp }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-password"
                        type="password"
                        onChange={ e => setPwd(e.target.value) }
                        placeholder="*********" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ performLogin } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Log In</button>
            </div>
        </Modal>
    )

    return [launch, component]
}